export default "__VITE_ASSET__D4xe7vw6__"